export enum SelfAssignmentCodeTypeEnum {
  DISABLED = 'DISABLED',
  WITH_CODE_ONLY = 'WITH_CODE_ONLY',
  CODE_OPTIONAL = 'CODE_OPTIONAL'
}